import { useMutation, useQueryClient } from 'react-query'
import { useParams } from 'react-router-dom'
import ProjectService from '../../../services/ProjectService'

type RenameProjectPayload = {
  organization: string
  name: string
  newName: string
}

export const useRenameProject = () => {
  const { org } = useParams()
  const queryClient = useQueryClient()

  return useMutation<any, Error, RenameProjectPayload>({
    mutationKey: ['rename-project'],
    mutationFn: ({ organization, name, newName }) => ProjectService.renameProject(organization, name, newName),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['projects', org] })
      queryClient.invalidateQueries({ queryKey: ['projects-structure'] })
    },
  })
}
